// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import BaiduMap from 'vue-baidu-map'
import axios from 'axios'

Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(BaiduMap, {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    ak: 'vAEpdIVegXXzBGGOBFb0LGQHs1CG0YA0'
});

Vue.prototype.axios = axios;

/* eslint-disable no-new */
new Vue({
    beforeCreate () {
    },
    created () {
    },
    beforeMount () {
    },
    mounted () {
        console.log('\n%c 无控 - 我命由我不由天 \n','background:#4153af;color:#ffffff','');

    },
    el: '#app',
    router,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js